import { claimsDetail } from './request';
import information from './../../claim/customerRecordManage/recordFrom/information.vue';
import claimsInfo from './../../claim/customerRecordManage/recordFrom/claimsInfo.vue';
export default {
  components: {
    information,
    claimsInfo
  },
  data() {
    return {
      info: undefined
    };
  },
  created() {
    claimsDetail({
      claimsReviewId: this.$route.params.id
    }, this.$route.params.type).then(res => {
      this.info = res;
    });
  }
};